<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/invoices">Invoices</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/invoice-detail">Invoice Detail</a>
                        </span>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div class="pane-header">
                                <h4 class="mt-2 mb-4">Invoice Details</h4>
                            </div>
                            <ng-container *ngIf="loading">
                                <div class="text-center">
                                    <app-loader></app-loader>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!loading">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="detials-pane invoice">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div
                                                        *ngIf="
                                                            invoice.barcode !==
                                                            null
                                                        "
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>Barcode</h6>
                                                        </div>
                                                        <div class="col-7 mt-2">
                                                            {{
                                                                invoice.barcode
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        *ngIf="
                                                            invoice.irn !== null
                                                        "
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>IRN</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            {{ invoice.irn }}
                                                        </div>
                                                    </div>
                                                    <!-- <div class="invoice-item mb-4 row">
                        <div class="col-5"><h6>PO NO.</h6></div>
                        <div class="col-7">
                          {{ invoice.reference_details.items[0].poNumber }}
                        </div>
                      </div> -->
                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>Invoice No.</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.invoice_number
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Invoice Amount
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.invoice_amount
                                                                        | inrdisplay
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Invoice Date
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.invoice_date
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            invoice.invoice_due_date !==
                                                            ''
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Invoice Due Date
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.invoice_due_date
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Tax Registration
                                                                Number
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.gstin
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>Invoice URL</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                <a
                                                                    target="_blank"
                                                                    href="{{
                                                                        invoice.file_link
                                                                    }}"
                                                                    rel="noopener"
                                                                >
                                                                    View PDF
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Purchase
                                                                Organisation
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice
                                                                        .reference_details
                                                                        .purchaseOrg
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            paymentDueDateExist
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Payment Due Date
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                *ngIf="
                                                                    invoice.payment_due_date !==
                                                                    null
                                                                "
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.payment_due_date
                                                                }}
                                                            </p>
                                                            <p
                                                                *ngIf="
                                                                    invoice.payment_due_date ===
                                                                    null
                                                                "
                                                                class="txt-adjust blur"
                                                            >
                                                                Not Available
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            !paymentDueDateExist
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Payment Due Date
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust blur"
                                                            >
                                                                Not Available
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            paymentAdviceExist
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Payment Advice
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                <a
                                                                    target="_blank"
                                                                    href="{{
                                                                        invoice.payment_advice_attachment
                                                                    }}"
                                                                    rel="noopener"
                                                                >
                                                                    View PDF
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            !paymentAdviceExist
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Payment Advice
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust blur"
                                                            >
                                                                Will be
                                                                available once
                                                                Invoice is Paid
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="utrExist"
                                                    >
                                                        <div class="col-5">
                                                            <h6>UTR Number</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.utr_number
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="!utrExist"
                                                    >
                                                        <div class="col-5">
                                                            <h6>UTR Number</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust blur"
                                                            >
                                                                Will be
                                                                available once
                                                                Invoice is Paid
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="paymentDateExist"
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Payment Date
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust"
                                                            >
                                                                {{
                                                                    invoice.payment_date
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            !paymentDateExist
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                Payment Date
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust blur"
                                                            >
                                                                Will be
                                                                available once
                                                                Invoice is Paid
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="
                                                            invoice.debit_note_attachment
                                                        "
                                                    >
                                                        <div class="col-5">
                                                            <h6>Debit Note</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                *ngIf="
                                                                    debitNoteExist
                                                                "
                                                                class="txt-adjust"
                                                            >
                                                                <a
                                                                    target="_blank"
                                                                    href="{{
                                                                        invoice.debit_note_attachment
                                                                    }}"
                                                                    rel="noopener"
                                                                >
                                                                    View PDF
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                        *ngIf="!debitNoteExist"
                                                    >
                                                        <div class="col-5">
                                                            <h6>Debit Note</h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <p
                                                                class="txt-adjust blur"
                                                            >
                                                                If Applicable
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invoice-item mb-2 row"
                                                    >
                                                        <div class="col-5">
                                                            <h6>
                                                                GST Reconciled?
                                                            </h6>
                                                        </div>
                                                        <div class="col-7">
                                                            <ng-container
                                                                *ngIf="
                                                                    invoice.gst_exist
                                                                "
                                                            >
                                                                <p
                                                                    class="txt-adjust"
                                                                    *ngIf="
                                                                        invoice.gst_reconciled ===
                                                                        'TRUE'
                                                                    "
                                                                >
                                                                    Yes
                                                                </p>
                                                                <p
                                                                    class="txt-adjust"
                                                                    *ngIf="
                                                                        invoice.gst_reconciled ===
                                                                        'FALSE'
                                                                    "
                                                                >
                                                                    No
                                                                </p>
                                                                <p
                                                                    class="txt-adjust"
                                                                    *ngIf="
                                                                        invoice.gst_reconciled ===
                                                                        'UNKNOWN'
                                                                    "
                                                                >
                                                                    Not
                                                                    Available
                                                                </p>
                                                            </ng-container>

                                                            <ng-container
                                                                *ngIf="
                                                                    !invoice.gst_exist
                                                                "
                                                            >
                                                                <p
                                                                    class="txt-adjust"
                                                                >
                                                                    Not
                                                                    Available
                                                                </p>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7">
                                        <h5 class="pb-4 status-pane-header">
                                            Invoice Status History
                                            <span (click)="statusInfo()"
                                                ><i
                                                    class="ri-information-fill"
                                                ></i
                                            ></span>
                                        </h5>
                                        <div class="status-pane">
                                            <ng-container
                                                *ngIf="
                                                    invoice.statuses.length !==
                                                    0
                                                "
                                            >
                                                <table
                                                    aria-describedby="invoice-status"
                                                    class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left invoice-status"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Status</th>
                                                            <th>Owner</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="
                                                                let status of invoice.statuses
                                                            "
                                                        >
                                                            <ng-container
                                                                *ngIf="
                                                                    status.creation_date !==
                                                                    ''
                                                                "
                                                            >
                                                                <td
                                                                    [ngClass]="[
                                                                        status.creation_date !==
                                                                        ''
                                                                            ? 'default'
                                                                            : 'text-shade',
                                                                        status.invoice_status ===
                                                                        'Rejected'
                                                                            ? 'rejected'
                                                                            : 'normal'
                                                                    ]"
                                                                >
                                                                    {{
                                                                        status.creation_date_sys
                                                                    }}
                                                                </td>
                                                                <td
                                                                    [ngClass]="[
                                                                        status.creation_date !==
                                                                        ''
                                                                            ? 'default'
                                                                            : 'text-shade',
                                                                        status.invoice_status ===
                                                                        'Rejected'
                                                                            ? 'rejected'
                                                                            : 'normal'
                                                                    ]"
                                                                >
                                                                    <span>
                                                                        {{
                                                                            status.invoice_status.replaceAll(
                                                                                "_",
                                                                                " "
                                                                            )
                                                                        }}
                                                                    </span>

                                                                    <span
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                                'Rejected' ||
                                                                            status.invoice_status ===
                                                                                'rejected'
                                                                        "
                                                                    >
                                                                        <ng-container
                                                                            *ngIf="
                                                                                invoice
                                                                                    .reference_details
                                                                                    .docType ===
                                                                                'PO2S - PO2S'
                                                                            "
                                                                        >
                                                                            <i
                                                                                *ngIf="
                                                                                    invoice.rejection1
                                                                                "
                                                                                class="ri-information-fill"
                                                                                data-toggle="tooltip"
                                                                                data-placement="bottom"
                                                                                title="{{
                                                                                    invoice
                                                                                        .rejections
                                                                                        .rej1
                                                                                        .reason
                                                                                }}"
                                                                            ></i>
                                                                            <i
                                                                                *ngIf="
                                                                                    invoice.rejection2
                                                                                "
                                                                                class="ri-information-fill"
                                                                                data-toggle="tooltip"
                                                                                data-placement="bottom"
                                                                                title="{{
                                                                                    invoice
                                                                                        .rejections
                                                                                        .rej2
                                                                                        .reason
                                                                                }}"
                                                                            ></i>
                                                                        </ng-container>

                                                                        <ng-container
                                                                            *ngIf="
                                                                                invoice.status_reason !==
                                                                                ''
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="ri-information-fill"
                                                                                data-toggle="tooltip"
                                                                                data-placement="bottom"
                                                                                title="{{
                                                                                    invoice.status_reason
                                                                                }}"
                                                                            ></i>
                                                                        </ng-container>
                                                                    </span>

                                                                    <span
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Pending_submission'
                                                                        "
                                                                    >
                                                                        <ng-container
                                                                            *ngIf="
                                                                                invoice
                                                                                    .reference_details
                                                                                    .docType ===
                                                                                'PO2S - PO2S'
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="ri-information-fill"
                                                                                data-toggle="tooltip"
                                                                                data-placement="top"
                                                                                title="This invoice is pending level 1 approval by the shipping team before processing."
                                                                            ></i>
                                                                        </ng-container>

                                                                        <ng-container
                                                                            *ngIf="
                                                                                invoice
                                                                                    .reference_details
                                                                                    .docType !==
                                                                                'PO2S - PO2S'
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="ri-information-fill"
                                                                                data-toggle="tooltip"
                                                                                data-placement="top"
                                                                                title="Sorry, there may be an issue. We will retry automatically later. If it has been more than 24hrs, contact support."
                                                                            ></i>
                                                                        </ng-container>
                                                                    </span>
                                                                </td>
                                                                <td
                                                                    [ngClass]="
                                                                        status.creation_date !==
                                                                        ''
                                                                            ? 'default'
                                                                            : 'text-shade'
                                                                    "
                                                                >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Pending_submission'
                                                                        "
                                                                        >Vendor</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Submitted'
                                                                        "
                                                                        >Vendor</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Accepted'
                                                                        "
                                                                        >Plant</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Approved'
                                                                        "
                                                                        >Plant</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'In Processing'
                                                                        "
                                                                        >GBS</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'In Query'
                                                                        "
                                                                        >JSW
                                                                        User</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Posted'
                                                                        "
                                                                        >GBS</ng-container
                                                                    >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Cleared'
                                                                        "
                                                                        >GBS</ng-container
                                                                    >

                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Paid'
                                                                        "
                                                                        >GBS</ng-container
                                                                    >
                                                                    <ng-container
                                                                        [ngClass]="
                                                                            status.invoice_status ===
                                                                            'Rejected'
                                                                                ? 'rejected'
                                                                                : 'normal'
                                                                        "
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Rejected'
                                                                        "
                                                                        >GBS</ng-container
                                                                    >

                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Pending Shipping Approval'
                                                                        "
                                                                        >Vendor
                                                                        Portal</ng-container
                                                                    >

                                                                    <ng-container
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Pending Veson Approval'
                                                                        "
                                                                        >Shipping
                                                                        Team</ng-container
                                                                    >
                                                                </td>
                                                                <td>
                                                                    <i
                                                                        *ngIf="
                                                                            status.invoice_status !==
                                                                            'Rejected'
                                                                        "
                                                                        [ngClass]="
                                                                            status.creation_date !==
                                                                            ''
                                                                                ? 'checked'
                                                                                : 'default'
                                                                        "
                                                                        class="ri-checkbox-circle-fill"
                                                                    >
                                                                    </i>
                                                                    <i
                                                                        *ngIf="
                                                                            status.invoice_status ===
                                                                            'Rejected'
                                                                        "
                                                                        [ngClass]="
                                                                            status.creation_date !==
                                                                            ''
                                                                                ? 'checked rejected'
                                                                                : 'default'
                                                                        "
                                                                        class="ri-checkbox-circle-fill"
                                                                    >
                                                                    </i>
                                                                </td>
                                                            </ng-container>
                                                        </tr>
                                                        <tr
                                                            *ngFor="
                                                                let status of invoice.statuses
                                                            "
                                                        >
                                                            <ng-container
                                                                *ngIf="
                                                                    status.creation_date !==
                                                                        '' &&
                                                                    status.invoice_status ===
                                                                        'Cleared' &&
                                                                    status.payment_adjusted ===
                                                                        'TRUE'
                                                                "
                                                            >
                                                                <td>
                                                                    {{
                                                                        status.creation_date_sys
                                                                    }}
                                                                </td>

                                                                <td>
                                                                    <span
                                                                        class="adjust-text"
                                                                    >
                                                                        Payment
                                                                        Adjusted</span
                                                                    >
                                                                    <span>
                                                                        <i
                                                                            class="ri-information-fill"
                                                                            data-toggle="tooltip"
                                                                            data-placement="bottom"
                                                                            title="This Invoice has been cleared against an open debit. Check Payment Advice for further details"
                                                                        ></i
                                                                    ></span>
                                                                </td>
                                                                <td>GBS</td>
                                                                <td>
                                                                    <i
                                                                        class="checked ri-checkbox-circle-fill"
                                                                    >
                                                                    </i>
                                                                </td>
                                                            </ng-container>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </ng-container>

                                            <div
                                                class="empty"
                                                *ngIf="
                                                    invoice.statuses.length ===
                                                    0
                                                "
                                            >
                                                <p>
                                                    <em>Invoice saved;</em>
                                                    Pending submission
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="loader-wrapper" *ngIf="showing">
                        <div class="loader-content status-sequence">
                            <div class="loader-text text-center my-3">
                                <h4>Invoice Status Sequence</h4>
                            </div>
                            <div class="loader-body">
                                <div class="container">
                                    <!-- <div class="text-brief text-center mb-3">
                                        All statuses as displayed on the UI
                                        today with their owner and explanations
                                    </div> -->
                                    <table
                                        aria-describedby="invoice-status"
                                        class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left"
                                    >
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Status
                                                </th>
                                                <th class="text-left">Owner</th>
                                                <th class="text-left">Brief</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Pending Submission</td>
                                                <td>Vendor</td>
                                                <td>
                                                    The invoice has been
                                                    successfully uploaded but
                                                    not yet submitted.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Submitted</td>
                                                <td>Vendor</td>
                                                <td>
                                                    The invoice has been
                                                    submitted and sent to JSW.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Accepted</td>
                                                <td>Plant</td>
                                                <td>
                                                    The invoice has been
                                                    accepted by JSW.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Approved</td>
                                                <td>Plant</td>
                                                <td>
                                                    The invoice has been
                                                    approved by user department
                                                    for further processing.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>In Processing</td>
                                                <td>GBS</td>
                                                <td>
                                                    The invoice is in processing
                                                    with GBS.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>In Query</td>
                                                <td>JSW User</td>
                                                <td>
                                                    There could be an issue with
                                                    your Invoice. Reach out to
                                                    the JSW support desk if you
                                                    have not received any
                                                    related communication.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Posted</td>
                                                <td>GBS</td>
                                                <td>
                                                    The invoice has been
                                                    processed and sent to Audit
                                                    for final review.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Cleared</td>
                                                <td>GBS</td>
                                                <td>
                                                    Invoice cleared for payment.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Paid</td>
                                                <td>GBS</td>
                                                <td>
                                                    Invoice paid and funds
                                                    transferred to vendor’s
                                                    account.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Rejected</td>
                                                <td>GBS</td>
                                                <td>
                                                    The invoice has been
                                                    rejected. Reach out to the
                                                    JSW support desk if you have
                                                    not received any related
                                                    communication.
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                        <td>Payment 
                                            Adjusted</td>
                                        <td>GBS</td>
                                        <td>
                                            Payment of invoice adjusted
                                        </td>
                                    </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="loader-footer text-center my-3">
                                <button
                                    class="btn btn-default"
                                    (click)="closeStatusInfo()"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
